(()=>{'use strict';
document.querySelectorAll('a[href^="#"]').forEach(link=>link.addEventListener('click',event=>{
 if(link.hasAttribute('data-bottom-offer'))return;
 const id=link.getAttribute('href').slice(1);if(!id||id==='shopifyReshowConsentBanner')return;
 const target=document.getElementById(id);if(!target)return;
 event.preventDefault();target.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
}));
document.querySelectorAll('[data-baby-gallery]').forEach(gallery=>{
 const main=gallery.querySelector('[data-baby-main]');
 gallery.querySelectorAll('[data-baby-thumb]').forEach(button=>button.addEventListener('click',()=>{
  main.src=button.dataset.src; main.alt=button.dataset.alt;
  gallery.querySelectorAll('[data-baby-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
 }));
});
document.querySelectorAll('[data-baby-offers]').forEach(group=>{
 const update=()=>{const input=group.querySelector('input:checked'); const label=group.closest('[data-baby-product]').querySelector('[data-baby-selected]');if(label&&input)label.textContent=input.dataset.label;
  if(input){
   const file={'1':'onepot','3':'trio',bundle:'pack'}[input.value];
   const image=document.querySelector('[data-baby-main]');
   const thumb=[...document.querySelectorAll('[data-baby-thumb]')].find(t=>t.dataset.src.includes('catalog-28-'+file));
   if(image&&thumb){image.src=thumb.dataset.src;image.alt=thumb.dataset.alt;document.querySelectorAll('[data-baby-thumb]').forEach(t=>t.setAttribute('aria-pressed',String(t===thumb)));}
   const name=document.querySelector('[data-baby-sticky-name]');const price=document.querySelector('[data-baby-sticky-price]');
   if(name)name.textContent={'1':'1 pot · 30 bâtonnets','3':'Trio · 3 pots',bundle:'Pack · 3 pots + 2 brosses'}[input.value];
   if(price)price.textContent=[input.dataset.money,input.dataset.shipping].filter(Boolean).join(' · ');
  }};
 group.addEventListener('change',update);update();
});
document.querySelectorAll('[data-select-baby-bundle]').forEach(link=>link.addEventListener('click',()=>{
 const option=document.querySelector('input[name="baby-pack"][value="bundle"]');
 if(option){option.checked=true;option.dispatchEvent(new Event('change',{bubbles:true}));}
}));
})();
